module.exports = __webpack_public_path__ + "img/new-logo.18446cfb.svg";